import * as React from 'react'

import { Button, Container, LazyImage, Text, UserContext } from '@doist/marketist'

import { useTranslation } from 'next-i18next'

import blogImage from './prefooter-blog@2x.png'
import blogImageWebp from './prefooter-blog@2x.webp'
import contactImage from './prefooter-contact@2x.png'
import contactImageWebp from './prefooter-contact@2x.webp'
import integrationsImage from './prefooter-integrations@2x.png'
import integrationsWebp from './prefooter-integrations@2x.webp'
import remoteGuidesImage from './prefooter-remote-guides@2x.png'
import remoteGuidesWebp from './prefooter-remote-guides@2x.webp'
import youtubeImage from './prefooter-youtube@2x.png'
import youtubeImageWebp from './prefooter-youtube@2x.webp'

import css from './PrefooterSection.module.css'

export type PrefooterVariant = {
    name: string
    backgroundColor: string
    ctaHref: string
    image: {
        src: string
        webp: string
    }
}

/** All the possible variants of a Prefooter component. */
export const PrefooterVariants: PrefooterVariant[] = [
    {
        name: 'contact',
        backgroundColor: 'var(--color-green-01)',
        ctaHref: '/help/articles/5863164524572',
        image: { src: contactImage, webp: contactImageWebp },
    },
    {
        name: 'blog',
        backgroundColor: 'var(--color-tw-secondary-light)',
        ctaHref: 'https://blog.doist.com',
        image: { src: blogImage, webp: blogImageWebp },
    },
    {
        name: 'youtube',
        backgroundColor: 'var(--color-dst-secondary-light)',
        ctaHref: 'https://www.youtube.com/channel/UCswk4ItiuSzXHQ_cw9NsQtg',
        image: { src: youtubeImage, webp: youtubeImageWebp },
    },
    {
        name: 'remoteGuides',
        backgroundColor: 'var(--color-tw-secondary-light)',
        ctaHref: 'https://www.youtube.com/channel/UCQ_61yRKscCnkIJBPoR15EA',
        image: { src: remoteGuidesImage, webp: remoteGuidesWebp },
    },
    {
        name: 'integrations',
        backgroundColor: 'var(--color-td-secondary-light)',
        ctaHref: '/remote-work-guides',
        image: { src: integrationsImage, webp: integrationsWebp },
    },
]
const [contactVariant] = PrefooterVariants

type PrefooterSectionProps = {
    variant?: PrefooterVariant
}

export function PrefooterSection({ variant = contactVariant }: PrefooterSectionProps) {
    const { t } = useTranslation('helpcenter')
    const { webpSupport } = React.useContext(UserContext)
    const illus = webpSupport ? variant.image.webp : variant.image.src

    return (
        <div className={css.prefooter} style={{ backgroundColor: variant.backgroundColor }}>
            <Container className={css.container}>
                <div className={css.imageContainer}>
                    <LazyImage src={illus} />
                </div>
                <div className={css.content}>
                    <Text tag="h3" size="major-base">
                        {t(`prefooter.${variant.name}.title`)}
                    </Text>

                    <Button href={variant.ctaHref} size="large">
                        {t(`prefooter.${variant.name}.link`)}
                    </Button>
                </div>
            </Container>
        </div>
    )
}
